import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {

  public currentPassword;
  public newPassword;
  public newPasswordCheck;

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

  add() {
    this.activeModal.close({
      currentPassword: this.currentPassword,
      newPassword: this.newPassword,
      newPasswordCheck: this.newPasswordCheck
    });
  }
}
